var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C4.4087 0.5 2.88258 1.13214 1.75736 2.25736C0.632141 3.38258 0 4.9087 0 6.5V21.5C0 23.0913 0.632141 24.6174 1.75736 25.7426C2.88258 26.8679 4.4087 27.5 6 27.5H21C22.5913 27.5 24.1174 26.8679 25.2426 25.7426C26.3679 24.6174 27 23.0913 27 21.5V20L32.4 24.05C32.7343 24.3007 33.1318 24.4534 33.5479 24.4909C33.9641 24.5284 34.3825 24.4493 34.7562 24.2625C35.13 24.0756 35.4443 23.7883 35.664 23.4329C35.8836 23.0774 36 22.6679 36 22.25V5.75C36 5.33215 35.8836 4.92255 35.664 4.5671C35.4443 4.21166 35.13 3.92441 34.7562 3.73754C34.3825 3.55067 33.9641 3.47157 33.5479 3.50909C33.1318 3.54662 32.7343 3.69929 32.4 3.95L27 8V6.5C27 4.9087 26.3679 3.38258 25.2426 2.25736C24.1174 1.13214 22.5913 0.5 21 0.5H6ZM27 11.75L33 7.25V20.75L27 16.25V11.75ZM24 6.5V21.5C24 22.2956 23.6839 23.0587 23.1213 23.6213C22.5587 24.1839 21.7956 24.5 21 24.5H6C5.20435 24.5 4.44129 24.1839 3.87868 23.6213C3.31607 23.0587 3 22.2956 3 21.5V6.5C3 5.70435 3.31607 4.94129 3.87868 4.37868C4.44129 3.81607 5.20435 3.5 6 3.5H21C21.7956 3.5 22.5587 3.81607 23.1213 4.37868C23.6839 4.94129 24 5.70435 24 6.5Z",
    fill: "#AD2F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.3cc39fcc9888e98c450d99c224637a68.svg";
export { ForwardRef as ReactComponent };